import { render, staticRenderFns } from "./StudentMentor.vue?vue&type=template&id=303dfa7c&scoped=true&"
import script from "./StudentMentor.vue?vue&type=script&lang=js&"
export * from "./StudentMentor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303dfa7c",
  null
  
)

export default component.exports